import React, { useEffect, useState } from "react";
import "./main.css";
import Hero from "../components/Hero.js";
import WorkExperience from "../components/WorkExperience.js";
import Certificates from "../components/Certificates.js";
import Skills from "../components/Skills.js";
import { fetchAbout } from "../api/portfolio";
import { defaultAbout } from "../constants/const";

const Main = () => {
  const [about, setAbout] = useState(defaultAbout);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;

    fetchAbout()
      .then((data) => {
        if (!cancelled) setAbout(data);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, []);

  if (loading) {
    return (
      <div className="main-body">
        <p className="content-status">Loading…</p>
      </div>
    );
  }

  const {
    heroInfo,
    sectionHeaders,
    workExperiences,
    certificates,
    skills,
  } = about;

  return (
    <div className="main-body">
      <Hero heroInfo={heroInfo} />

      <div className="main-content">
        <WorkExperience
          sectionTitle={sectionHeaders && sectionHeaders.workExperiences}
          workExperiences={workExperiences || []}
        />
        <Certificates
          sectionTitle={sectionHeaders && sectionHeaders.certificates}
          certificates={certificates || []}
        />
        <Skills sectionHeaders={sectionHeaders} skills={skills} />
      </div>
    </div>
  );
};

export default Main;
